var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrow_drop_up_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow_drop_up_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.395 8.167l2.961 2.962c.04.04.072.085.092.133a.364.364 0 01-.345.509H6.896a.351.351 0 01-.272-.113.376.376 0 01-.103-.262c0-.014.041-.103.123-.266l2.96-2.963a.555.555 0 01.792 0z",
    fill: "#fff"
  }))));
}
export default SvgArrowDropUp;